import * as React from 'react';
export const santanderSvg = React.forwardRef(function santanderSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FE0000',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M16.3 7c0 2.42 4.09 5.12 4.09 7.9 0 0 0 .27-.12.56 3.82.8 6.52 2.7 6.52 4.92 0 2.99-4.82 5.44-10.78 5.46-.04.02-.08 0-.12 0-5.9 0-10.7-2.38-10.7-5.35 0-2.22 2.93-4.02 6.46-4.98 0 1.23 4.02 5.12 4.11 6.69 0 0 .02.13.02.29 0 .07 0 .15-.02.22.87-.45.87-1.9.87-1.9 0-3.4-3.9-4.91-3.9-8.26 0-1.3.6-2.26 1.14-2.53v.94c0 2.43 4.23 5.15 4.23 7.37v.73c.98-.39.98-2.2.98-2.2 0-3.07-3.92-4.77-3.92-8.28 0-1.3.6-2.26 1.15-2.53V7',
      }),
    ),
  );
});
santanderSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var santander = {
  category: 'brand',
  colorable: false,
  name: 'santander',
  svg: santanderSvg,
};
